import * as React from 'react'
import iconInformation from 'images/icon_information.svg'

interface Props {
  children: React.ReactNode
  style?: React.CSSProperties
}

const Component: React.FC<Props> = ({ children, style }) => (
  <>
    <section className="info" style={style}>
      <img src={iconInformation} alt="information" className="info-icon" />
      <div className="mx-4 my-3">{children}</div>
    </section>
  </>
)

export default Component
